import {Component, inject, Input, OnInit} from '@angular/core';
import {ListMaintenanceService} from './services/list-maintenances.service';
import {ClaimDto} from 'src/app/auto-generated-server-dtos/claim/claim-dto';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ListMaintenanceTermService} from './services/list-maintenance-terms.service';
import {DateOnly} from 'src/app/auto-generated-server-dtos/date-only';
import dayjs from 'dayjs';
import { DeleteMaintenanceModalComponent } from './delete-maintenance-modal/delete-maintenance-modal.component';
import { MaintenanceRecordDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/maintenance-record/maintenance-record-dto';
import { MaintenanceTermDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/maintenance-record/maintenance-term-dto';
import { AddMaintenanceModalComponent } from './add-maintenance-modal/add-maintenance-modal.component';
import { MaintenanceRecordWithDueDate } from "../../../../models/MaintenanceRecordWithDueDate";

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss',
})
export class MaintenanceComponent implements OnInit  {
  @Input() claimDto!: ClaimDto;

  maintenances: MaintenanceRecordWithDueDate[] = [];
  terms: MaintenanceTermDto[] = [];
  errorOccurred = false;
  isLoading = true;
  isRefreshing = true;

  ngbModal = inject(NgbModal);
  listMaintenanceService = inject(ListMaintenanceService);
  listMaintenanceTermService = inject(ListMaintenanceTermService);

  ngOnInit(): void {
    this.listMaintenanceTermService.listMaintenaceTerm().subscribe({
      next: (terms) => {
        this.terms = terms;
      }
    });

    this.getMaintenanceRecords();
  }

  private getMaintenanceRecords() {
    this.isRefreshing = true;
    this.listMaintenanceService.listMaintenance(this.claimDto.vehicle.vehicleId).subscribe({
      next: (resp) => {
        this.isLoading = false;
        this.isRefreshing = false;
        this.maintenances = this.parseMaintenanceRecords(resp);
      },
      error: () => {
        this.isLoading = false;
        this.isRefreshing = false;
        this.errorOccurred = true;
      }
    });
  }

  private parseMaintenanceRecords(records: MaintenanceRecordDto[]): MaintenanceRecordWithDueDate[] {
    return records.map(record => ({
      ...record,
      dueDate: this.calculateDueDate(record.date, record.term.description)
    }));
  }
  
  private calculateDueDate(dateOfMaintenance: DateOnly, termLength: string) {
    let term = termLength.split(" ");
    if (!termLength.length || !term.length) {
      return;
    }
    let termLengthValueStr = term[0];
    let isMonth = term[1].toLowerCase().includes("month");
    let termLengthValue = parseInt(termLengthValueStr);

    if (!isMonth && termLengthValue) {
      return dayjs(dateOfMaintenance).add(termLengthValue, 'year').toDate();
    }

    if (isMonth && termLengthValue) {
      return dayjs(dateOfMaintenance).add(termLengthValue, 'months').toDate();
    }

    return null;
  }

  openCreateModal() {
    const modalRef = this.ngbModal.open(AddMaintenanceModalComponent, { size: "md" });
    modalRef.componentInstance.terms = this.terms;
    modalRef.componentInstance.claimDto = this.claimDto;

    modalRef.result.then(
      (wasSuccessful: boolean) => {
        if (wasSuccessful) {
          this.getMaintenanceRecords();
        }
      },
      () => {}  // modal dismissed/cancelled, do nothing
    );
  }

  openDeleteModal(maintenance: MaintenanceRecordWithDueDate) {
    const modalRef = this.ngbModal.open(DeleteMaintenanceModalComponent, { size: "md" });
    modalRef.componentInstance.maintenance = maintenance;

    modalRef.result.then(
      (wasSuccessful: boolean) => {
        if (wasSuccessful) {
          this.getMaintenanceRecords();
        }
      },
      () => {}  // modal dismissed/cancelled, do nothing
    );
  }
  
}